import Divider       from "_components/atoms/divider";
import FetchMore     from "_components/atoms/fetchMoreLoader";
import Typography    from "_components/atoms/typography";
import MobileTabs    from "_components/molecules/mobile/tabs";
import VideoCardList from "_components/organisms/videoCardList";

import { formatLiveSessions } from "../utils";

import useStyles from "./styles";

const component = ( { data, onChangeTab, tabsList, activeTab, isLoadingMore, isEmpty, fetchMore, __data } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.mobileMainContainer }>
			<div className = { classes.mobileHeader }>
				<Typography
					className = { classes.liveText }
					title     = { "Live" }
				/>

				<Divider />
			</div>

			<MobileTabs
				background     = "secondary"
				defaultTab     = { activeTab }
				onClickHandler = { onChangeTab }
				tabs           = { tabsList }
			/>

			<div className = { classes.listContainer }>

				<VideoCardList
					cardType = { "stream" }
					list     = { formatLiveSessions ( data ) }
				/>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isEmpty }
					isLoading  = { isLoadingMore }
				/>
			</div>

		</div>
	);
};

export default component;